export class OutIn {
  constructor
    (
      {
        id = null,
        outInClass = ``,
        outInTime = ``,
        // invCode='',
        // invName='',
        // yard= ``, 
        // pile= ``, 
        // area= ``, 
        // matClass= ``, 
        // matCatalog= ``,
        matCode = ``,
        matName = ``,
        invCode = '',
        invName = '',
        // outInOutSection='',
        // outInInSection='',
        outInQuantity = '',
        outInPerson = ''
      } = {}
    ) {
    this.id = id;
    this.outInClass = outInClass;
    this.outInTime = outInTime;
    this.invCode =invCode;
    this.invName = invName;
    this.matCode = matCode;
    this.matName = matName;
    this.outInQuantity = outInQuantity;
    this.outInPerson = outInPerson;
  }
}
export function gridFields() {
  return Object.freeze([
    {
      key: 'matName',
      label: 'lbl.basic.matName',
      sortable: true,
      form: {
        type: 'input'
      }
    },
    {
      key: 'matCode',
      label: 'lbl.basic.matCode',
      sortable: true,
      form: {
        type: 'input'
      }
    },
    {
      key: 'outInQuantity',
      label: 'lbl.inventory.outInQuantity',
      sortable: true,
      form: {
        type: 'input'
      }
    },
    {
      key: 'outInTime',
      label: 'lbl.inventory.outInTime',
      sortable: true,
      form: {
        type: 'date'
      }
    },
    {
      key: 'invCode',
      label: 'lbl.inventory.invCode',
      sortable: true,
      notInTable:"true",
      form: {
        type: 'input'
      }
    },
    {
      key: 'invName',
      label: 'lbl.inventory.invName',
      sortable: true,
      form: {
        type: 'input'
      },
    },
    {
      key: 'outInClass',
      label: 'lbl.inventory.outInClass',
      sortable: true,
      form: {
        type: 'select',
        options: [
          { value: 'O', text: '出库' },
          { value: 'I', text: '入库' }
        ]
      }
    },
  ]);
}
export const fields = Object.freeze(Object.keys(new OutIn()).map(i => 'entity.' + i));
export const filterFields =
  [   
    'filter.matCodeFilter',
    'filter.invCodeFilter',
    'filter.outInTimeFilter',
    'filter.stFilter',
    'filter.etFilter',
    'filter.outInMethodFilter',
    'filter.outInClassFilter'
  ];
export const filter =
{
  'matCodeFilter': "",
  'invCodeFilter': "",
  'outInTimeFilter': "",
  'stFilter': "",
  'etFilter': "",
  'outInMethodFilter': "",
  'outInClassFilter': ""
};